import { render, staticRenderFns } from "./Show-dose.vue?vue&type=template&id=10ad1d10&scoped=true&"
import script from "./Show-dose.vue?vue&type=script&lang=js&"
export * from "./Show-dose.vue?vue&type=script&lang=js&"
import style0 from "./Show-dose.vue?vue&type=style&index=0&id=10ad1d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ad1d10",
  null
  
)

export default component.exports